import { FC } from 'react';
import { IconColor, IconProps } from '../types';

import styles from './ButtonSvg.module.scss';
import cx from 'classnames';

export const GoldenButton: FC<IconProps> = ({
  width = 122,
  height = 39,
  disabled = false,
}) => {
  return (
    <div
      style={{ width, height }}
      className={cx(styles.goldenButton, {
        [styles.disabled]: disabled,
      })}
    ></div>
  );
};

export const LightGreenButton: FC<IconProps> = ({
  width = 122,
  height = 39,
  disabled = false,
}) => {
  return (
    <div
      style={{ width, height }}
      className={cx(styles.customLightGreenButton, {
        [styles.disabled]: disabled,
      })}
    ></div>
  );
};

export const DefaultButton: FC<IconProps> = ({ width, height, disabled = false }) => {
  return (
    <div
      style={{ width, height }}
      className={cx(styles.customButton, {
        [styles.disabled]: disabled,
      })}
    ></div>
  );
};

export const ButtonSvg: FC<
  IconProps & { gradient?: 'default' | 'gold' | 'light-green' }
> = ({ width = 122, height = 39, gradient = 'default', disabled = false, ...props }) => {
  const disabledColor =
    gradient !== 'gold' ? IconColor.BACKGROUND_SECONDARY : 'url(#gold-gradient)';

  const gradientId =
    gradient === 'default' ? 'url(#radial-gradient)' : 'url(#light-green-gradient)';

  if (gradient === 'gold') {
    return <GoldenButton width={width} height={height} disabled={disabled} />;
  } else if (gradient === 'light-green') {
    return <LightGreenButton width={width} height={height} disabled={disabled} />;
  } else if (gradient === 'default') {
    return <DefaultButton width={width} height={height} disabled={disabled} />;
  }

  return (
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 122 39"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      {...props}
    >
      <mask id="path-1-inside-1_6595_1423" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.73244 0H119.268C119.097 0.294173 119 0.635713 119 1C119 2.10457 119.895 3 121 3C121.364 3 121.706 2.90261 122 2.73244V36.2676C121.706 36.0974 121.364 36 121 36C119.895 36 119 36.8954 119 38C119 38.3643 119.097 38.7058 119.268 39H2.73244C2.90261 38.7058 3 38.3643 3 38C3 36.8954 2.10457 36 1 36C0.635713 36 0.294173 36.0974 0 36.2676V2.73244C0.294173 2.90261 0.635713 3 1 3C2.10457 3 3 2.10457 3 1C3 0.635713 2.90261 0.294173 2.73244 0Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.73244 0H119.268C119.097 0.294173 119 0.635713 119 1C119 2.10457 119.895 3 121 3C121.364 3 121.706 2.90261 122 2.73244V36.2676C121.706 36.0974 121.364 36 121 36C119.895 36 119 36.8954 119 38C119 38.3643 119.097 38.7058 119.268 39H2.73244C2.90261 38.7058 3 38.3643 3 38C3 36.8954 2.10457 36 1 36C0.635713 36 0.294173 36.0974 0 36.2676V2.73244C0.294173 2.90261 0.635713 3 1 3C2.10457 3 3 2.10457 3 1C3 0.635713 2.90261 0.294173 2.73244 0Z"
        fill={disabled ? disabledColor : gradientId}
      />
      <path
        d="M119.268 0L120.999 1.00147L122.735 -2H119.268V0ZM2.73244 0V-2H-0.735022L1.00122 1.00145L2.73244 0ZM122 2.73244H124V-0.73502L120.999 1.00122L122 2.73244ZM122 36.2676L120.999 37.9988L124 39.735V36.2676H122ZM119.268 39V41H122.735L120.999 37.9985L119.268 39ZM2.73244 39L1.00122 37.9986L-0.73502 41H2.73244V39ZM0 36.2676H-2V39.735L1.00145 37.9988L0 36.2676ZM0 2.73244L1.00145 1.00122L-2 -0.735022V2.73244H0ZM119.268 -2H2.73244V2H119.268V-2ZM121 1C121 0.996812 121 0.996853 121 0.998707C120.999 1.00023 120.999 1.00122 120.999 1.00147L117.536 -1.00147C117.195 -0.411058 117 0.274767 117 1H121ZM121 1H117C117 3.20914 118.791 5 121 5V1ZM120.999 1.00122C120.999 1.00109 121 1.00058 121.001 1.00017C121.003 0.999667 121.003 1 121 1V5C121.725 5 122.411 4.80516 123.001 4.46365L120.999 1.00122ZM124 36.2676V2.73244H120V36.2676H124ZM121 38C121.003 38 121.003 38.0003 121.001 37.9998C121 37.9994 120.999 37.9989 120.999 37.9988L123.001 34.5364C122.411 34.1948 121.725 34 121 34V38ZM121 38V34C118.791 34 117 35.7909 117 38H121ZM120.999 37.9985C120.999 37.9988 120.999 37.9998 121 38.0013C121 38.0031 121 38.0032 121 38H117C117 38.7252 117.195 39.4111 117.536 40.0015L120.999 37.9985ZM2.73244 41H119.268V37H2.73244V41ZM1 38C1 38.0032 0.999667 38.0031 1.00017 38.0013C1.00058 37.9998 1.00109 37.9988 1.00122 37.9986L4.46365 40.0014C4.80516 39.4111 5 38.7253 5 38H1ZM1 38H5C5 35.7909 3.20914 34 1 34V38ZM1.00145 37.9988C1.00121 37.9989 1.00023 37.9994 0.998712 37.9998C0.996862 38.0003 0.996819 38 1 38V34C0.274753 34 -0.411063 34.1948 -1.00145 34.5364L1.00145 37.9988ZM-2 2.73244V36.2676H2V2.73244H-2ZM1 1C0.996821 1 0.996865 0.999667 0.998716 1.00017C1.00024 1.00058 1.00122 1.00109 1.00145 1.00122L-1.00145 4.46365C-0.411067 4.80517 0.274749 5 1 5V1ZM1 1V5C3.20914 5 5 3.20914 5 1H1ZM1.00122 1.00145C1.00109 1.00122 1.00058 1.00024 1.00017 0.998716C0.999667 0.996865 1 0.996821 1 1H5C5 0.274749 4.80517 -0.411067 4.46365 -1.00145L1.00122 1.00145Z"
        fill="url(#paint1_linear_6595_1423)"
        mask="url(#path-1-inside-1_6595_1423)"
      />
      <defs>
        <linearGradient
          id="gold-gradient"
          x1="133"
          y1="2.04444"
          x2="87.87"
          y2="116.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D38B24" />
          <stop offset="0.0720001" stopColor="#DFB066" />
          <stop offset="0.152" stopColor="#EDDEA5" />
          <stop offset="0.242" stopColor="#F3C962" />
          <stop offset="0.347" stopColor="#FAD682" />
          <stop offset="0.485" stopColor="#FFE8B2" />
          <stop offset="0.652" stopColor="#D99D51" />
          <stop offset="0.802" stopColor="#D69C4D" />
          <stop offset="1" stopColor="#F0DFA7" />
        </linearGradient>

        <radialGradient
          id="radial-gradient"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(59.6444 18.2) rotate(82.8677) scale(21.8356 67.3609)"
        >
          <stop stopColor="#255144" />
          <stop offset="1" stopColor="#043023" />
        </radialGradient>

        <radialGradient
          id="light-green-gradient"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(59.6444 18.2) rotate(90) scale(21.8356 67.3609)"
        >
          <stop stopColor="#1AA279" />
          <stop offset="1" stopColor="#133F32" />
        </radialGradient>

        <linearGradient
          id="paint1_linear_6595_1423"
          x1="61"
          y1="39"
          x2="61"
          y2="4.77776e-07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D38B24" />
          <stop offset="0.0720001" stopColor="#DFB066" />
          <stop offset="0.152" stopColor="#EDDEA5" />
          <stop offset="0.242" stopColor="#F3C962" />
          <stop offset="0.347" stopColor="#FAD682" />
          <stop offset="0.485" stopColor="#FFE8B2" />
          <stop offset="0.652" stopColor="#D99D51" />
          <stop offset="0.802" stopColor="#D69C4D" />
          <stop offset="1" stopColor="#F0DFA7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
